import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  OnDestroy,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { isDefinedNotEmpty } from '@softline/core';

// TODO:
//  Download minified file for qr-code generation instead of relying on the npm package...
//  Lazy load only when rendering this component - this should not be in the initial bundle...

declare global {
  class QRCode {
    constructor(name: string, options: object);
    clear(): void;
    makeCode(data: string): void;
  }
}

@Component({
  selector: 'soft-qrcode',
  imports: [CommonModule],
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeComponent implements OnDestroy {
  readonly data = input.required<string | undefined>();

  readonly element = viewChild('qrCodeHostElement', { read: ElementRef });

  qrcode: QRCode | undefined = undefined;

  constructor() {
    afterRenderEffect({
      write: (onCleanup) => {
        onCleanup(() => {
          this.qrcode?.clear?.();
        });

        const element = this.element()?.nativeElement;
        const text = this.data();

        if (!element || !isDefinedNotEmpty(text)) {
          this.qrcode?.clear?.();
          this.qrcode = undefined;
          return;
        }

        if (this.qrcode) {
          this.qrcode.clear(); // clear the code.
          this.qrcode.makeCode(text); // make another code.
          return;
        }

        this.qrcode =
          this.qrcode ??
          new QRCode(element, {
            text: this.data(),
            colorDark: '#000',
            colorLight: '#fff',
          });
      },
    });
  }

  ngOnDestroy() {
    this.qrcode?.clear?.();
    this.qrcode = undefined;
  }
}
